<template>
  <div class="basic_wrap">
    <!-- 顶部自定义导航 -->
    <div class="custom_header">
      <div class="back_btn" @click="$router.back()">
        <span class="arrow_left"></span>
      </div>
      <div class="header_title">{{ dramaTitle || $t('utils.gmzq') }}</div>
    </div>

    <div class="main_content">
      <!-- 1. 基础信息卡片 -->
      <div class="card_box">
        <div class="info_top_center">
          <div class="proj_big_img">
            <img :src="item.img" alt="cover">
          </div>
          <div class="proj_main_title">{{ dramaTitle }}</div>
          <div class="proj_tags">
            <span class="tag vip">{{ requiredLevelname }}</span>
            <span class="tag auto">📝 {{ $t('utils.lunlog50') }}</span>
            <span class="tag safe">💎 {{ $t('utils.lunlog49') }}</span>
          </div>
        </div>
      </div>

      <!-- 2. 投资类型卡片 -->
      <div class="card_box info_type_card">
        <div class="type_row">
          <div class="icon_box">📋</div>
          <div class="type_label">{{ $t('invest.type') }}</div>
        </div>
        <div class="type_desc">{{ $t('index.method' + item.type) }}</div>
      </div>

      <!-- 3. 项目信息卡片 (2x3网格) -->
      <div class="card_box">
        <div class="section_title">
          <span class="icon">📊</span> {{ $t('invest.info') || '项目信息' }}
        </div>
        
        <div class="proj_data_grid">
          <div class="data_item">
            <div class="data_val black">{{ common.currency_symbol_basic() }}{{ item.newmin }}</div>
            <div class="data_label">{{ $t('index.amount') }}</div>
          </div>
          <div class="data_item">
            <div class="data_val purple">{{ common.currency_symbol_basic() }}{{ item.fan }}</div>
            <div class="data_label">{{ $t('utils.lunlog31') }}</div>
          </div>
          <div class="data_item">
            <div class="data_val black">
              <span v-if="item.type == 3">{{ item.day }}{{ $t('index.hour') }}</span>
              <span v-else>{{ item.day }}{{ $t('index.day') }}</span>
            </div>
            <div class="data_label">{{ $t('index.cycle') }}</div>
          </div>
          <div class="data_item">
            <div class="data_val blue">{{ item.rate }}%</div>
            <div class="data_label">{{ $t('index.rate') }}</div>
          </div>
          <div class="data_item">
            <div class="data_val blue">{{ common.currency_symbol_basic() }}{{ item.days }}/{{ $t('index.day') }}</div>
            <div class="data_label">{{ $t('invest.income') }}</div>
          </div>
          <div class="data_item">
            <div class="data_val green">{{ common.currency_symbol_basic() }}{{ item.zong }}</div>
            <div class="data_label">{{ $t('utils.goodszong') }}</div>
          </div>
        </div>
      </div>

      <!-- 4. 项目详情卡片 -->
      <div class="card_box">
        <div class="section_title">
          <span class="icon">📄</span> {{ $t('invest.detail') || 'detail' }}
        </div>
        <div class="detail_content">
          {{ item.description || '' }}
        </div>
      </div>
      
      <div style="height: 100px;"></div> <!-- 底部防遮挡占位 -->
    </div>

    <!-- 底部固定操作按钮 -->
    <div class="bottom_action_bar">
      <div class="action_btn" @click="handleBuyClick">
        <span class="action_icon">💰</span> {{ $t('utils.lunlog29') }}
      </div>
    </div>

    <!-- ==================================================================== -->
    <!-- 【核心修改】确认投资弹窗 (完美匹配截图) -->
    <!-- ==================================================================== -->
    <div v-if="showModal" class="modal-overlay" @click.self="showModal = false">
      <div class="modal-sheet">
        <!-- 标题区 -->
        <div class="modal_header">
          <div class="header_icon">☑️</div>
          <div class="header_title_text">{{ $t('utils.msg2') }}</div>
        </div>

        <!-- 信息展示浅灰块 -->
        <div class="modal_info_block">
          <div class="info_row">
            <span class="label">{{ $t('utils.msg1') }}</span>
            <span class="value bold">{{ dramaTitle }}</span>
          </div>
          <div class="info_row">
            <span class="label">{{ $t('utils.msg4') }}</span>
            <span class="value bold">{{ common.currency_symbol_basic() }}{{ item.balance }}</span>
          </div>
          <div class="info_row">
            <span class="label">{{ $t('index.amount') }}</span>
            <span class="value bold blue">{{ common.currency_symbol_basic() }}{{ price }}</span>
          </div>
        </div>

        <!-- 按钮区 -->
        <div class="modal_actions">
          <button class="confirm_btn" @click="submit()">{{ $t('invest.submit') }}</button>
          <button class="cancel_btn" @click="showModal = false">{{ $t('utils.code7') }}</button>
        </div>
      </div>
    </div>
    <!-- ==================================================================== -->

    <!-- Toast 提示 -->
    <div class="toast" :class="{ show: toastVisible }">{{ toastMsg }}</div>
  </div>
</template>

<script>
import Vue from 'vue';
import bsHeader from '../../components/bsHeader.vue'
import Fetch from '../../utils/fetch'
import { Icon, Popup, Field, Cell, CellGroup } from 'vant';
Vue.use(Icon).use(Popup).use(Field).use(Cell).use(CellGroup);

export default {
  name: "InvestDetail",
  components: { bsHeader },
  data() {
    return {
      data: [],
      item: { min: 0, type: 1, rate: 0, day: 0 },
      user: [],
      money: "",
      income: 0,
      showPopup: false,
      loading: false,
      dramaTitle: '',
      dramaRating: '',
      dramaViews: '',
      episode: {},
      price: '',
      profitRatio: '',
      cycleDays: '',
      principalReturn: '',
      settlementMethod: '',
      currentLevel: '',
      currentLevelname: '',
      requiredLevel: '',
      requiredLevelname: '',
      showModal: false,
      toastVisible: false,
      toastMsg: '',
      toastTimer: null,
    };
  },
  created() {
    if (window.plus) {
      plus.navigator.setStatusBarBackground('#FFFFFF');
      plus.navigator.setStatusBarStyle('dark');
    }
    this.$parent.footer('user', false);
  },
  mounted() {
    this.start();
  },
  methods: {
    start() {
      Fetch('/index/item_detail', {
        id: this.$router.history.current.params.code
      }).then(r => {
        this.item = r.data.item;
        this.dramaTitle = r.data.item.title;
        this.dramaRating = r.data.item.rating;
        this.dramaViews = r.data.item.bofang;
        this.episode.img = r.data.item.img;
        this.price = r.data.item.newmax;
        this.profitRatio = r.data.item.rate;
        this.cycleDays = r.data.item.day;
        this.principalReturn = r.data.item.fan;
        this.requiredLevelname = r.data.item.level_name;
        this.requiredLevel = r.data.item.mid;
        this.currentLevelname = r.data.user.level_name;
        this.currentLevel = r.data.user.mid;
        this.item.balance = r.data.user.balance;
        this.user = r.data.user;
        this.item = r.data.item;
      })
    },
    canBuy() {
      return this.currentLevel >= this.requiredLevel;
    },
    showToast(msg) {
      if (this.toastTimer) clearTimeout(this.toastTimer);
      this.toastMsg = msg;
      this.toastVisible = true;
      this.toastTimer = setTimeout(() => {
        this.toastVisible = false;
      }, 1500);
    },
    handleBuyClick() {
      // 购买前置校验
      if (!this.user.login) {
        this.$toast(this.$t('invest.loginFirst'));
        return;
      }
      if (this.user.limit) {
        var times = this.item.num;
        if (this.item.num >= 2) times = 2;
        this.$toast(this.$t('invest.investNum') + this.item.num + this.$t('utils.times' + times));
        return;
      }
      if (this.user.balance - this.item.min < 0) {
        this.$toast(this.$t('invest.moneyNotEnough'));
        return;
      }
      if (this.user.mid < this.item.mid) {
        this.$toast(this.$t('utils.lunlog32'));
        return;
      }
      if (this.user.limit_today) {
        this.$toast(this.$t('invest.investNumEmpty'));
        return;
      }
      // 校验通过弹出确认框
      this.showModal = true;
    },
    submit() {
      if (this.loading) return false;
      this.loading = true;
      Fetch('/user/invest', { id: this.item.id }).then(r => {
        if (r.code == '218') {
          this.$toast(this.$t(r.info));
          this.loading = false;
          return;
        } else {
          this.$router.replace('/invest/record');
        }
      })
    }
  }
};
</script>

<style lang="less" scoped>
/* 浅色网格背景 */
.basic_wrap {
  min-height: 100vh;
  background: linear-gradient(180deg, #f8fbff, #eef4fb 42%, #f6f8fc);
  padding-bottom: 20px;
}

/* 自定义顶部导航 */
.custom_header {
  display: flex;
  align-items: center;
  padding: 16px 16px 12px;
  background: transparent;
  .back_btn {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border-radius: 50%;
    box-shadow: 0 2px 6px rgba(0,0,0,0.05);
    cursor: pointer;
    margin-right: 12px;
    .arrow_left {
      display: block;
      width: 8px;
      height: 8px;
      border-left: 2px solid #333;
      border-bottom: 2px solid #333;
      transform: rotate(45deg);
      margin-left: 3px;
    }
  }
  .header_title {
    flex: 1;
    font-size: 16px;
    font-weight: 700;
    color: #111;
  }
}

.main_content {
  padding: 0 16px;
}

/* 通用白色卡片 */
.card_box {
  background: #ffffff;
  border-radius: 16px;
  padding: 20px 16px;
  box-shadow: 0 2px 12px rgba(24, 61, 122, 0.06);
  margin-bottom: 14px;
  border: 1px solid rgba(220, 229, 239, 0.5);
}

/* 1. 基础信息卡片 */
.info_top_center {
  display: flex;
  flex-direction: column;
  align-items: center;
  .proj_big_img {
    width: 110px;
    height: 110px;
    border-radius: 16px;
    overflow: hidden;
    margin-bottom: 14px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.08);
    img { width: 100%; height: 100%; object-fit: cover; }
  }
  .proj_main_title {
    font-size: 18px;
    font-weight: 700;
    color: #111;
    margin-bottom: 10px;
  }
  .proj_tags {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    justify-content: center;
    .tag {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      background: #fef7ec;
      color: #b45309;
      font-size: 11px;
      font-weight: 600;
      padding: 4px 10px;
      border-radius: 14px;
      &.vip { background: #fef3c7; color: #b45309; }
      &.auto { background: #e0f2fe; color: #0369a1; }
      &.safe { background: #fefce8; color: #a16207; }
    }
  }
}

/* 2. 投资类型卡片 */
.info_type_card {
  padding: 16px;
  .type_row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
    .icon_box {
      width: 28px; height: 28px;
      background: #eef4ff; border-radius: 50%;
      display: flex; align-items: center; justify-content: center;
      font-size: 14px;
    }
    .type_label { font-size: 13px; font-weight: 600; color: #333; }
  }
  .type_desc {
    font-size: 14px;
    font-weight: 700;
    color: #2563eb;
    padding-left: 36px;
  }
}

/* 标题 */
.section_title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 700;
  color: #111;
  margin-bottom: 16px;
  .icon { font-size: 16px; }
}

/* 3. 2x3 数据网格 */
.proj_data_grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  
  .data_item {
    background: #f6f9ff;
    border-radius: 10px;
    padding: 12px 6px;
    text-align: center;
    .data_val {
      font-size: 14px;
      font-weight: 700;
      color: #000;
      margin-bottom: 6px;
      &.black { color: #111; }
      &.blue { color: #1d4ed8; }
      &.green { color: #16a34a; }
      &.purple { color: #8b5cf6; }
    }
    .data_label { font-size: 12px; color: #777; }
  }
}

/* 4. 项目详情 */
.detail_content {
  font-size: 14px;
  color: #555;
  line-height: 1.6;
}

/* 底部固定按钮 */
.bottom_action_bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #ffffff;
  box-shadow: 0 -4px 20px rgba(0,0,0,0.06);
  padding: 12px 16px;
  padding-bottom: calc(12px + env(safe-area-inset-bottom));
  display: flex;
  justify-content: center;
  z-index: 99;
  border-top: 1px solid #eee;
  
  .action_btn {
    width: 100%;
    height: 48px;
    background: #2563eb;
    color: #fff;
    border-radius: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
    transition: opacity 0.2s;
    &:active { opacity: 0.85; }
    .action_icon { font-size: 18px; }
  }
}

/* ================================================== */
/* 【核心修改】投资确认弹窗样式区 */
/* ================================================== */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-sheet {
  width: 90%;
  max-width: 380px;
  background: #ffffff;
  border-radius: 24px;
  padding: 20px 20px 24px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  animation: popIn 0.25s ease;

  /* 标题 */
  .modal_header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px;
    .header_icon {
      font-size: 20px;
      color: #e50914;
    }
    .header_title_text {
      font-size: 18px;
      font-weight: 700;
      color: #111;
    }
  }

  /* 浅灰信息块 */
  .modal_info_block {
    background: #f0f5fc;
    border-radius: 14px;
    padding: 16px 14px;
    margin-bottom: 20px;

    .info_row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 6px 0;
      font-size: 14px;

      .label {
        color: #666;
        font-weight: 500;
      }
      .value {
        color: #111;
        &.bold { font-weight: 700; }
        &.blue { color: #2563eb; }
      }
    }
  }

  /* 按钮组 */
  .modal_actions {
    display: flex;
    flex-direction: column;
    gap: 12px;

    .confirm_btn {
      width: 100%;
      height: 48px;
      background: #2563eb;
      color: #fff;
      border: none;
      border-radius: 24px;
      font-size: 16px;
      font-weight: 700;
      cursor: pointer;
      transition: opacity 0.2s;
      &:active { opacity: 0.85; }
    }

    .cancel_btn {
      width: 100%;
      height: 48px;
      background: #ffffff;
      color: #666;
      border: 1px solid #e5e7eb;
      border-radius: 24px;
      font-size: 15px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.2s;
      &:active { background: #f9f9f9; }
    }
  }
}

@keyframes popIn {
  from { transform: scale(0.9); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

/* Toast */
.toast {
  position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%) scale(0.85);
  background: rgba(0,0,0,0.8); color: #fff; padding: 14px 24px; border-radius: 12px;
  font-size: 14px; font-weight: 600; z-index: 9999; pointer-events: none; opacity: 0;
  transition: all 0.3s; &.show { opacity: 1; transform: translate(-50%, -50%) scale(1); }
}
</style>